<template>
  <div class="privacy">
    <Pagenationtopimg />
    <Pagenationtop :pagenation_title="pagenation_title" path="privacy" />
    <div class="privacy-container">
        <div class="content"
        v-html="main_data">
        </div>
    </div>
  </div>
</template>

<script>
import Pagenationtopimg from "../components/pagenationimg/index.vue";
import Pagenationtop from "../components/pagenationtop/index.vue";
export default {
    data(){
        return{
            pagenation_title:[
                '隱私權政策'
            ],
            main_data:'浩捍實業股份有限公司(下稱本公司)為向使用者提供「浩捍實業股份有限公司」之販售服務（下稱本服務，本服務詳細內容請參「浩捍實業股份有限公司使用條款」），本公司須向使用者取得部分必要之個人資料，並將依本公司個人資料保護政策（下稱本政策）蒐集、處理及利用使用者所提供之個人資料。<br>1.本公司就個人資料之蒐集、處理及利用，將尊重使用者之權益，並取得使用者同意，依誠實及信用方法為之，未逾越第3條所述特定目的之必要範圍，並與第3條之蒐集目的具有正當合理之關聯。<br>2.個人資料之蒐集<br>( 1 ) 如使用者擬使用本服務之會員相關服務，使用者必須註冊成為會員（下稱會員），會員註冊或登入程序中可能要求使用者輸入手機電話號碼、姓名、生日、性別、電子郵件信箱地址、住址等基本資料；如使用者選擇以Facebook帳號註冊會員，本公司將取得該Facebook帳號網路身份認證之相關資料。<br>( 2 ) 使用者使用本服務之期間，其登入位址、登錄時間、以及在網站內的促銷活動等相關資料將會被記錄。<br>3.個人資料之蒐集目的<br>( 1 ) 除為提供本服務外，使用者所提供之資料僅供作為本公司內部流量分析及網路行為調查，以提供使用者更好的使用體驗及服務。<br>( 2 ) 在特定情形下，如使用者希望參加本公司問卷調查等行銷活動時，本服務之相關網站可能會要求使用者提供資料，以便於寄送贈品、提供額外服務等；於此情形，本公司將另行告知使用者蒐集該等資料之目的。<br>( 3 ) 個人資料的使用，除本條所述目的、依法令規定、行政機關或法院之命令、或本公司另有事前說明外，本服務絕對不會將使用者的個人資料提供給第三人或作為本條所述目的以外之目的使用。<br>( 4 ) 未經使用者事前同意，本公司不得將未去識別化之個人資料用作數據分析統計或市場分析。<br>4.個人資料利用之期間、地區、對象及方式<br>( 1 ) 期間：本服務存續期間。<br>( 2 ) 地區：本公司、本公司之關係企業及下述( 5 ) 之第三人所在地。<br>( 3 ) 對象：本公司、本公司之關係企業及下述( 5 ) 之第三人。<br>( 4 ) 方式：以電腦化或非電腦化等方式。<br>( 5 ) 本公司為提供本服務，可能使用第三人（包括但不限於本公司之關係企業及本服務相關之外包廠商）提供之服務，而必須分享使用者個人資料予該第三人，於此情形，本公司將要求該第三人遵守本政策規定，負擔與本公司於本政策規定之同一義務。<br>( 6 ) 處理個人資料之契約目的消失或期限屆滿時，本公司將停止處理及利用該資料。但經使用者書面同意者，不在此限。<br>5.為保障會員之個人資料及安全，會員在本服務內之資料均將以密碼保護。敬請會員妥善保管個人的帳號及密碼。<br>( 1 ) 密碼請定期變更。不建議使用出生年月日、電話號碼等。<br>( 2 ) 請勿將帳號密碼轉借、交付抑或是公開給親友使用。<br>( 3 ) 於本公司的問與答或聯絡信箱裡，請勿填入個人使用密碼。<br>6.個人資料的維護<br>( 1 ) 使用者就本公司蒐集之個人資料，得隨時依第8條第( 3 ) 項規定聯絡本公司要求以下項目：<br>i. 查詢或請求閱覽。<br>ii. 請求製給複製本。<br>iii. 請求補充或更正。<br>iv. 請求停止蒐集、處理或利用。<br>v. 請求刪除。<br>( 2 ) 就前項第i款及第ii款之要求，使用者得提出可資確認之身分證明文件申請；委託他人代為申請者，另應提出可資確認之身分證明。本公司並得酌收合理費用。<br>( 3 ) 個人資料正確性有爭議者，本公司將即時停止該筆資料之處理及利用或採取其他保護措施。<br>7.本公司違反本政策之規定，致使用者權益受損害者，將依個人資料保護法等相關法律負損害賠償責任。<br>8.其他<br>( 1 ) 使用者得自由選擇是否提供個人資料予本服務或於提供後向本公司提出第6條第( 1 ) 項第iv款或第v款之要求，惟一旦使用者拒絕提供完成註冊程序所需之必要資料，或所提供之資料不完整，將可能導致本服務全部或部分無法執行。<br>( 2 ) 由於網際網路資料的傳輸不能保證百分之百的安全。因此，儘管本公司努力保護使用者的個人資料安全，也無法保證使用者傳送給本服務，或接收從本服務傳送出資料之安全。一旦收到使用者傳送的資料，本公司將盡力以合理之技術及程序，保障使用者個人資料之安全。本公司之電腦系統具有符合一般可合理期待之安全性，本公司對個人資料之存取均有建立識別碼、通行碼之管理制度，並加設資料存取控制。個人資料檔案，將指定專人依相關法令辦理安全維護事項，防止個人資料被竊取、竄改、毀損、滅失或洩漏，並將定期不定期稽核檔案管理情形。<br>( 3 ) 使用者如擬依第6條規定行使權利或針對上述個人資料保護如有不明處，請來信至本公司電子郵件地址[customer_cht@ichiran.com]或以下地址，本公司將於完成核實使用者身分之必要調查後儘快處理並回覆說明。依第6條規定行使權利者，本公司將於三十日內處理，未能於該期間內處理者，會將其原因以書面通知使用者。<br>( 4 ) 本公司因本服務而知悉或持有使用者之交易紀錄及其他相關資料，將予以保密，不為不當使用。<br>本公司違反本項規定致使用者受有損害者，將依個人資料保護法等相關法律負賠償責任。'
        }
    },
    created(){
        this.$store.commit('closeOverlay')
    },
    components: {
        Pagenationtopimg,
        Pagenationtop,
    },

}
</script>

<style>

</style>